export const SVC_KINDS = [
  { key: "gst", label: "GST RO Billing", short: "G" },
  { key: "ro", label: "RO List", short: "R" },
  { key: "warranty", label: "Warranty", short: "W" },
  { key: "sales", label: "Sales", short: "S" },
];

export const kindLabel = (k) => SVC_KINDS.find((x) => x.key === k)?.label || "Unrecognised";

export const fmtINR = (n) => (n == null ? "—" : Math.round(n).toLocaleString("en-IN"));

export const fmtWhen = (s) => (s ? s.slice(0, 16).replace("T", " ") : "");

export const fmtDay = (s) => (s ? new Date(`${s}T00:00:00`).toLocaleDateString("en-IN", { day: "2-digit", month: "short" }) : "—");

export const fmtDealers = (list, groupFile) => {
  if (!list?.length) return "";
  if (groupFile || list.length > 3) return `${list.length} workshops`;
  return list.join(", ");
};

export const STATUS_CLS = {
  complete: "bg-emerald-500",
  partial: "bg-amber-400",
  missing: "bg-red-200",
  future: "bg-transparent",
};
